module.exports = __webpack_public_path__ + "img/sqs.f8d21b69.svg";